import { useTheme } from "@mui/material";
import { useEffect } from "react";
import styled from "styled-components";


const AboutPage = () => {

  const theme = useTheme();
  return (
    <>
    </>
  );
};

export default AboutPage;
